/* unplugin-vue-components disabled */import { render } from "./Empty.vue?vue&type=template&id=df96887e&scoped=true"
const script = {}

import "./Empty.vue?vue&type=style&index=0&id=df96887e&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/yunibao-invite-h5-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df96887e"]])

export default __exports__